module.exports = __webpack_public_path__ + "assets/img/activity-default.fe87c233.png";